import {Injectable} from '@angular/core';
import {AuthService} from "@core/auth/auth.service";

@Injectable()
export class AppInitService {

  constructor(private _auth: AuthService) {
  }

  initializeApp(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = window.location.href;

      if (url.indexOf('code=') !== -1) {
        let code = url.substring(url.indexOf('code=') + 'code='.length).trim();
        this._auth.processLogin(code).then(success => {
          console.log('Process login success');
          if (success) {
            resolve();
          }else{
            reject();
          }
        }).catch(err => {
          console.log("Error processLogin with code: " + code);
          // console.error(err);
          reject(err);
        });
      }
      else{
        resolve();
      }
    });
  }
}

export function appInit(appInitService: AppInitService) {
  return () => appInitService.initializeApp()
    .then(() => {
      console.log("successfully call app Init");
      return true;
    })
    .catch((err) => {
      console.log("error with init");
    });
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/AppInit.service.ts